/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.sendInteractions'

export { $nsid }

/** Send information about interactions with feed items back to the feed generator that served them. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    feed: l.optional(l.string({ format: 'at-uri' })),
    interactions: l.array(
      l.ref<FeedDefs.Interaction>((() => FeedDefs.interaction) as any),
    ),
  }),
  l.jsonPayload({}),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
